var map = {
	"./1/results/dad.json": 2523,
	"./1/results/jane.json": 2524,
	"./1/results/john.json": 2525,
	"./1/results/june.json": 2526,
	"./1/results/mom.json": 2527,
	"./list.json": 995
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2522;


//////////////////
// WEBPACK FOOTER
// ./src/services/API/fixtures/assessments ^\.\/.*\.json$
// module id = 2522
// module chunks = 0